import Vue from 'vue';

const VeeValidate = require('vee-validate');

window.Vue = require('vue');
window.axios = require('axios');

Vue.use(VeeValidate);

// Components that can appear anywhere within the App:
Vue.component('contact-form', require('./components/contact-form.vue').default);
Vue.component('contact-modal', require('./components/contact-modal.vue').default);

// The App itself:
window.App = new Vue({
	el: '#app',
	mounted: function () {
		require('svg4everybody')();
	},
});



// WEBPACK FOOTER //
// ./src/js/vue/app.js